<template>
  <detail
    :showDesc="false"
    :isEditDesc="false"
    :isEditName="false"
    :data="data"
    :onManager="onManager"
    :base-info="baseInfo" />
</template>

<script>
import * as R from 'ramda'
import { getDurationLabel } from '@/utils/utils'
import { CATEGORY_LABEL_MAP, getPoliciesValueMap } from '../config'

export default {
  name: 'StrategyDefinitionDetail',
  props: {
    onManager: {
      type: Function,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        {
          field: 'category',
          title: this.$t('cloudenv.text_502'),
          formatter: ({ row, cellValue }) => {
            return CATEGORY_LABEL_MAP[cellValue]
          },
        },
        {
          field: 'policies',
          title: this.$t('cloudenv.text_501'),
          width: 220,
          slots: {
            default: ({ row }) => {
              if (row.category === 'server_duration') {
                const tags = row.policies.server_duration.map(item => {
                  return <a-tag class='mb-2'>{getDurationLabel(item)}</a-tag>
                })
                return [<list-body-cell-popover text={CATEGORY_LABEL_MAP[row.category] + ':' + this.$t('common_701', [row.policies.server_duration.length])} max-width="400px">
                  { ...tags }
                </list-body-cell-popover>]
              }
              const ret = []
              const valueMap = getPoliciesValueMap()
              R.forEachObjIndexed((value, key) => {
                ret.push(<a-tag class='mb-2 mr-1'>{ valueMap[row.category][key] }{ value === true ? '' : '：' + value }</a-tag>)
              }, row.policies)
              const len = Object.keys(row.policies).length
              return [<list-body-cell-popover text={this.$t('cloudenv.text_557', ['', len])} max-width="400px">
                <div style="display: inline-flex; flex-wrap: wrap; max-width: 40vw;">
                  {...ret}
                </div>
              </list-body-cell-popover>]
            },
          },
        },
      ],
    }
  },
}
</script>
